module.controller(
    'samplingDetailCtrl',
    [ '$scope', '$rootScope', '$state', '$q', 'planSamplingService', 'alertService', 
        function($scope, $rootScope, $state, $q, planSamplingService, alertService) {

            $scope.operationType = $state.current.data.type;
            $scope.idPlanSampling = $state.params.idPlan;
            $scope.idSampling =  $state.params.idSampling;
            $scope.sampling = {
            	product: {},
                site: {},
                area: {},
                frequency: []
            };
            
            $scope.samplingAnalysisInit = [];
            $scope.samplingAnalysisSelected = [];
            $scope.planSamplingProducts = [];
            $scope.validProduct = true;
            
            $scope.loading = false;
            
            $scope.idClient;
            
            $scope.init = function(idPlan){
            	$scope.loading = true;
            	var load1 = true;
            	var load2 = true;
            	planSamplingService.getPlanSamplingHome(idPlan).then(function(response) {
            		load1 = false;
                    $scope.loading = load2;
                    var responseData = response.getData();
                    $scope.idClient = responseData.client.id;
                }, function(response) {
                	load1 = false;
                    $scope.loading = load2;
                });
                
                planSamplingService.getPlanSamplingProducts(idPlan).then(function(response) {
                	load2 = false;
                    $scope.loading = load1;
                    $scope.planSamplingProducts  = response.getData();
                }, function(response) {
                	load2 = false;
                    $scope.loading = load1;
                });
            }

            $scope.init($state.params.idPlan);
            
            $scope.load = function(idPlan, idSampling) {
                $scope.loading = true;
                var load1 = true;
                var load2 = true;

                planSamplingService.getSamplingOne(idPlan, idSampling).then(function(response) {
                	load1 = false;
                    $scope.loading = load2;

                    var responseData = response.getData();
                    
                    $scope.sampling = {
                    	product: {
                    		selected:[responseData.product]
                    	},
                    	site:{
                    		selected:[responseData.site]
                    	},
                    	area:{
                    		selected:[responseData.area]
                    	},
                    	frequency:[getConstantById(FREQUENCY,responseData.frequency)],
                    	numSamples: responseData.numSamples,
                    	observations: responseData.observations
                    };
                }, function(response) {
                	load1 = false;
                    $scope.loading = load2;
                });
              
                planSamplingService.getSamplingAnalysisList(idPlan, idSampling).then(function(response) {
                	load2 = false;
                    $scope.loading = load1;

                    var result = response.getData();
                    
                    var elements = result.map(
                    	function(e){
                    		var map = {};
                    		map = e.technique;
                    		map.idSamplingAnalysis = e.id;
                    		map.dilutionExpected = e.dilutionExpected;
                    		map.observations = e.observations;
                    		map.analysis = e.analysis;
                    		map.analysis.regulation = e.regulation;
                    		return map;
                    	}
                    );
                    
                    $scope.samplingAnalysisInit  = elements;
                }, function(response) {
                	load2 = false;
                    $scope.loading = load1;
                });
            };
 
            $scope.onSamplingAnalysisChange=function(samplingAnalysis,typeOperation){
            	var deferred = $q.defer();
            	//si se esta creando, no se hace la solicitud de una vez
            	if($scope.operationType === 'create'){
            		deferred.resolve('c');
            		return deferred.promise;
            	}
        		var updateModel = {
        				idRegulation: samplingAnalysis.analysis.regulation.id,
        				idAnalysis: samplingAnalysis.analysis.id,
        				idTechnique: samplingAnalysis.id,
        				observations: samplingAnalysis.observations,
        				dilutionExpected: samplingAnalysis.dilutionExpected
        		};
        		
        		if(typeOperation === 'create'){
        			planSamplingService.addSamplingAnalysis($scope.idPlanSampling, $scope.idSampling, updateModel).then(function(response) {
                		deferred.resolve();
                    }, function(response) {
                    	deferred.reject();
                    });
        		}else if(typeOperation === 'remove'){
        			//si solo queda 1 no se deja eliminar
        			if($scope.samplingAnalysisSelected.length <= 1){
        				alertService.showDanger("No se puede eliminar!!! Debe quedar al menos una técnica asociada!!!");
        				deferred.reject();
        				return deferred.promise;
        			}
        			var idSamplingAnalysis = getIdSamplingAnalysis(samplingAnalysis);
                	planSamplingService.removeSamplingAnalysis($scope.idPlanSampling, $scope.idSampling, idSamplingAnalysis).then(function(response) {
                		deferred.resolve();
                    }, function(response) {
                    	deferred.reject();
                    });
        		}else {
            		var idSamplingAnalysis = getIdSamplingAnalysis(samplingAnalysis);
                	planSamplingService.updateSamplingAnalysis($scope.idPlanSampling, $scope.idSampling, idSamplingAnalysis,updateModel).then(function(response) {
                		deferred.resolve();
                    }, function(response) {
                    	deferred.reject();
                    });        			
        		}
            	return deferred.promise;
            };
           
            $scope.onSelectProduct=function(product){
            	$scope.validProduct = true;
            	if(!$scope.planSamplingProducts)
            		return;
            	if(!product.length > 0)
            		return;
            	for(i=0;i<$scope.planSamplingProducts.length; i++){
            		if($scope.planSamplingProducts[i].id === product[0].id){
            			$scope.validProduct = false;
            			return;
            		}
            	}            	
            }
            
            $scope.onRemoveProduct= function(oldValue){
            	if(!$scope.samplingAnalysisSelected || $scope.samplingAnalysisSelected.length === 0)
            		return;
            	alertService.showSwtWarning('<span style="color:red">Si cambia el producto, se eliminan los análisis de muestreo!!!</span><br /> ¿Esta seguro?', 
            		function(confirmed){
	                	if(confirmed){
	        				if ($scope.operationType == 'create') 
	        					$scope.samplingAnalysisSelected = [];
	        				else{
	        					$scope.loading = true;
	        					//se borran en la base de datos
	        					planSamplingService.removeAllSamplingAnalysis($scope.idPlanSampling, $scope.idSampling).then(function(response) {
	        	                    $scope.loading = false;
	        	                    $scope.samplingAnalysisSelected = [];
	        	                    alertService.showSuccess('Análisis de muestreo eliminados satisfactoriamente');
	        	                }, function(response) {
	        	                    $scope.loading = false;
	        	                    $scope.sampling.product.selected = oldValue;
	        	                });
	        				}
	        			}else{
	        				$scope.sampling.product.selected = oldValue;
	        			}
                });
            }
           
            /**
             *
             */
            $scope.sendAction = function() {
                if ($scope.operationType == 'create') {
                    $scope.create();
                } else {
                    $scope.update();
                }
            };

            /**
             *
             */
            $scope.create = function() {
                alertService.showSwtQuestion('Crear Muestreo', function() {
                    $scope.loading = true;

                    var createModel = {
                    	frequency: $scope.sampling.frequency[0].enumName,
                    	numSamples: $scope.sampling.numSamples,
                    	idProduct: $scope.sampling.product.selected[0].id,
                    	idSite: $scope.sampling.site.selected[0].id,
                    	idArea: $scope.sampling.area.selected[0].id,
                    	samplingAnalysis:[]
                    };
                    
                    $scope.samplingAnalysisSelected.forEach(
                    	function(sa){
                    		var item = {
                        			idRegulation: sa.analysis.regulation.id,
                        			idAnalysis: sa.analysis.id,
                        			idTechnique: sa.id,
                        			observations: sa.observations,
                        			dilutionExpected: sa.dilutionExpected
                        	};
                        	createModel.samplingAnalysis.push(item);
                    	}	
                    );

                    planSamplingService.addSampling($scope.idPlanSampling, createModel).then(function(response) {
                        $scope.loading = false;
                        alertService.showSuccess('Muestreo creado satisfactoriamente');
                        $state.go('home.planSamplingHome',{id: $scope.idPlanSampling});
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };

            /**
             *
             */
            $scope.update = function() {
                alertService.showSwtQuestion('Actualizar Muestreo', function() {
                    $scope.loading = true;

                    var updateModel = {
                    	frequency: $scope.sampling.frequency[0].enumName,
                    	numSamples: $scope.sampling.numSamples,
                    	
                    	idSite: $scope.sampling.site.selected[0].id,
                    	idArea: $scope.sampling.area.selected[0].id
                    };

                    planSamplingService.updateSampling($scope.idPlanSampling,  $scope.idSampling, updateModel).then(function(response) {
                        $scope.loading = false;
                        alertService.showSuccess('Muestreo actualizado satisfactoriamente');
                        $state.go('home.planSamplingHome',{id: $scope.idPlanSampling});
                    }, function(response) {
                        $scope.loading = false;
                    });
                });
            };

            $scope.onSiteChange =  function(){
            	$scope.sampling.area={};
            }
            
            getIdSamplingAnalysis=function(samplingAnalysis){
            	var e = $scope.samplingAnalysisInit.find(function(sa){
            			return sa.id ===  samplingAnalysis.id;
            		}
            	);
            	if(e)
            		return e.idSamplingAnalysis;
            	return null;
            }
            
            if ($scope.operationType == 'update') {
                $scope.load($state.params.idPlan, $state.params.idSampling);
            }
        } ]);


